<mat-card
  class="unit-card-container"
  (click)="navigateToDayList(gradeUnit.unitGradeLevel, gradeUnit.unitNumber)"
  (keydown.enter)="
    navigateToDayList(gradeUnit.unitGradeLevel, gradeUnit.unitNumber)
  "
>
  <div class="cover-image">
    <img
      [src]="gradeUnit.unitCoverImageUrl"
      [alt]="getAltText(gradeUnit.unitNumber)"
      tabindex="0"
    />
  </div>
  <div class="unit-title header-text" [matTooltip]="gradeUnit.unitTitle">
    {{ gradeUnit.unitTitle | truncateText: 20 }}
  </div>
  <div class="unit-description" [matTooltip]="gradeUnit.unitDescription">
    {{ gradeUnit.unitDescription | truncateText: 20 }}
  </div>
  <div class="unit-description" [matTooltip]="getNGSSDescription()">
    {{ getNGSSDescription() | truncateText: 20 }}
  </div>
  <ng-container *ngIf="checkPermission.isSuperAdmin">
    <div
      class="unit-status-container header-text"
      [ngClass]="checkStatus(gradeUnit.status)"
    >
      <ng-container *ngIf="showUnitNumber">
        {{ 'Unit' | uppercase }} {{ gradeUnit.unitNumber }}
      </ng-container>

      <div class="status">
        <ng-container [ngSwitch]="gradeUnit.status">
          <ng-container *ngSwitchCase="statusEnum.PENDING">
            {{ 'Work in Progress' | uppercase }}
          </ng-container>
          <ng-container *ngSwitchCase="statusEnum.READY">
            {{ 'Ready' | uppercase }}
          </ng-container>
        </ng-container>
      </div>
    </div>
  </ng-container>
</mat-card>
